import { CustomerSupportType, OverviewSlideGroups } from '../../../api/models/customer-support.enums';
import { CustomerSupportTutorialItem } from '../../../models';

export const recipesTutorials: CustomerSupportTutorialItem[] = [
  {
    tutorialTitle: 'Create and manage Recipes, Ingredients and Menus',
    tutorialText:
      'Create recipes and menus to view food costing, with real-time pricing, recipe notifications and menu analysis tools.',
    customerSupportType: CustomerSupportType.Recipes,
    overviewGroup: OverviewSlideGroups.Recipes,
  },
];
